/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if(boostSDAppConfig?.filterSettings) {
  boostSDAppConfig.filterSettings.filterAvoidStickyHeader = ['.header.fixed'];
}

// Function calculate the retail price and render HTML
function buildPriceItem(data, boostSDCustomConfig, formatMoneyHelper) {
    let html = '';
    let __vendor = data.vendor;
    let actual_discount = data.price_min;
    let actual_discount_max = data.price_max;
    let retails_price = '';
    let retails_price_max = '';

    for (let i = 0; i <= boostSDCustomConfig.customer_tags.length - 1; i++) {
        for (let j = 0; j <= boostSDCustomConfig.customer_available_tags.length - 1; j++) {
            const cat_downcase = boostSDCustomConfig.customer_available_tags[j].toLowerCase();
            const c_tag_downcase = boostSDCustomConfig.customer_tags[i].toLowerCase();
            if (cat_downcase == c_tag_downcase) {
                let retails_customer_group = c_tag_downcase;
                let retails_by_vendor = boostSDCustomConfig.customer_retails[j].split('\n');
                for (let rv of retails_by_vendor) {
                    let vendor_retail = rv.split(':');
                    let vendor_retail_strip = vendor_retail[0].trim();
                    if (vendor_retail_strip == __vendor) {
                        //console.log(vendor_retail_strip, __vendor, vendor_retail)
                        let retails_discount_percentage = parseFloat(vendor_retail[1].trim());
                        if (retails_discount_percentage !== 0) {
                            actual_discount = data.price_min * retails_discount_percentage / 100;
                            retails_price = data.price_min - actual_discount;

                            actual_discount_max = data.price_max * retails_discount_percentage / 100;
                            retails_price_max = data.price_max - actual_discount_max;
                        }
                    }
                }
            }
        }
    }

    if (retails_price !== '' && data.price_max > data.price_min) {
        let remainder = retails_price % 100;
        if (remainder == 0) {
            retails_price = formatMoneyHelper(Number(retails_price), window.boostSDAppConfig?.shop?.money_format, true);
        } else if (remainder >= 50 && remainder <= 99) {
            retails_price = formatMoneyHelper(Number(retails_price), window.boostSDAppConfig?.shop?.money_format, true);
        } else {
            retails_price = formatMoneyHelper(Number(retails_price), window.boostSDAppConfig?.shop?.money_format, true);
        }

        let remainder_max = retails_price_max % 100;
        if (remainder_max == 0) {
            retails_price_max = formatMoneyHelper(Number(retails_price_max), window.boostSDAppConfig?.shop?.money_format, true);
        } else if (remainder_max >= 50 && remainder_max <= 99) {
            retails_price_max = formatMoneyHelper(Number(retails_price_max), window.boostSDAppConfig?.shop?.money_format, true);
        } else {
            retails_price_max = formatMoneyHelper(Number(retails_price_max), window.boostSDAppConfig?.shop?.money_format, true);
        }
        
        html += '<span class="ranged-price">';
        html += '<del>' + formatMoneyHelper(Number(data.price_min), window.boostSDAppConfig?.shop?.money_format, true) + ' - ' + formatMoneyHelper(Number(data.price_max), window.boostSDAppConfig?.shop?.money_format, true) + '</del><br/>';
        html += retails_price + ' - ' + retails_price_max;
        html += '</span>';
    } else if (retails_price !== '') {
        let remainder = retails_price % 100;
        if (remainder == 0) {
            retails_price = formatMoneyHelper(Number(retails_price), window.boostSDAppConfig?.shop?.money_format, true);
        } else if (remainder >= 50 && remainder <= 99) {
            retails_price = formatMoneyHelper(Number(retails_price), window.boostSDAppConfig?.shop?.money_format, true);
        } else {
            retails_price = formatMoneyHelper(Number(retails_price), window.boostSDAppConfig?.shop?.money_format, true);
        }

        html += '<del>' + formatMoneyHelper(Number(data.price_min), window.boostSDAppConfig?.shop?.money_format, true) + '</del> ' + retails_price;
    } else if (data.price_max > data.price_min) {
        html += '<span class="ranged-price">';
        html += formatMoneyHelper(Number(data.price_min), window.boostSDAppConfig?.shop?.money_format, true) + ' - ' + formatMoneyHelper(Number(data.price_max), window.boostSDAppConfig?.shop?.money_format, true);
        if (data.compare_at_price_max > data.price_min) {
            html += '<br/><s>' + formatMoneyHelper(Number(data.compare_at_price_max), window.boostSDAppConfig?.shop?.money_format, true) + '</s>';
        }
        html += '</span>';
    } else {
        html += formatMoneyHelper(Number(data.price_min), window.boostSDAppConfig?.shop?.money_format, true);
        if (data.compare_at_price_max > data.price_min) {
            html += '<br/><s>' + formatMoneyHelper(Number(data.compare_at_price_max), window.boostSDAppConfig?.shop?.money_format, true) + '</s>';
        }
    }

    return html;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        let formatMoneyHelper;

        componentRegistry.useComponentPlugin('FormatCurrency', {
            name: 'Show Trailing Zeros',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        // Start customization--------------------------------------------
                        formatMoneyHelper = element.getHelpers().formatMoney;
                        // End-------------------------------------------------------------
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });

        componentRegistry.useComponentPlugin('QuickView', {
            name: 'customize quickview',
            apply: () => ({
                props: (props) => {
                    try {
                        //limit images to 3
                        if (props.isOpen && props.productData.tags.includes("quickview-images")) {
                            let threeImages = props.productData.images_info.slice(0, 3)
                            props.productData.images_info = threeImages
                        }
                    } catch (error) {
                        console.warn(error);
                    }
                    return props
                },
                afterRender(element) {
                    try {
                        const props = element.getParams().props

                        if (props.isOpen) {
                            const quickViewProductData = element.getParams().props.productData;

                            const productItem = document.querySelector('.boost-sd__quick-view[product-id="' + quickViewProductData.id + '"]')

                            //const metafeild = quickViewProductData.metafields.find(metafeild => metafeild.key = "tab_content")
                            const metafeild_1 = quickViewProductData.metafields;

                            const tags = quickViewProductData.tags;
                            let isBackorder = false;
                            for (let i = 0; i < tags.length; i++) {
                                const tag_val = tags[i];
                                //console.log(tag_val);
                                if(tag_val == 'backorder'){
                                    isBackorder = true;
                                }
                            }
                            //console.log(isBackorder);
                            if (boostSDCustomConfig && boostSDCustomConfig?.customer_tags && boostSDCustomConfig.customer_tags.length > 0) {
                                let newPriceHtml = buildPriceItem(quickViewProductData, boostSDCustomConfig, formatMoneyHelper);
                                if (productItem.querySelector('.boost-sd__quick-view-price')) {
                                    productItem.querySelector('.boost-sd__quick-view-price').innerHTML = newPriceHtml;
                                }
                            } else {
                                if (quickViewProductData.price_max > quickViewProductData.price_min) {
                                    //var rangePrice = quickViewProductData.price_max - quickViewProductData.price_min;
                                    productItem.querySelector('.boost-sd__quick-view-price').innerHTML = "<span class='boost-sd__format-currency'><span>$" + new Intl.NumberFormat().format(quickViewProductData.price_min) + " – $" + new Intl.NumberFormat().format(quickViewProductData.price_max) + "</span></span>";
                                }
                            }

                            for (let i = 0; i < metafeild_1.length; i++) {
                                const key = metafeild_1[i].key;
                                const value = metafeild_1[i].value;
                                //console.log(key);
                                if (key == "tab_content") {
                                    const Elm = document.querySelector('p')
                                    Elm.classList.add('metafield-info-quick-view')
                                    Elm.innerHTML = value
                                    productItem.querySelector('.boost-sd__quick-view-details-link').insertAdjacentElement('beforebegin', Elm)
                                }
                                if (key == "estimated_ship_date") {
                                    if (isBackorder == true){
                                        const Elm = document.querySelector('p')
                                        Elm.classList.add('metafield-info-estimated_shipdate')
                                        Elm.innerHTML = "Estimated ship date: " + value;
                                        productItem.querySelector('.boost-sd__quick-view-quantity').insertAdjacentElement('afterend', Elm)
                                    }
                                }
                                if (key == "quickview_description") {
                                    const Elm = document.querySelector('p')
                                    Elm.classList.add('metafield-quick-view-description')
                                    Elm.innerHTML = value
                                    productItem.querySelector('.boost-sd__quick-view-btn').insertAdjacentElement('beforebegin', Elm)
                                    productItem.querySelector('.boost-sd__quick-view-btn').style.display = "none"
                                    productItem.querySelector('.boost-sd__quick-view-quantity').style.display = "none"
                                    var swatch = document.querySelector('.boost-sd__product-swatch');
                                    if (typeof(swatch) != 'undefined' && swatch != null) {
                                        productItem.querySelector('.boost-sd__product-swatch').style.display = "none"
                                    }
                                }
                            }
                        }
                    } catch (error) {
                        console.warn(error);
                    }
                },
            }),
        });

        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Customize Product Item Component',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        const parentElement = element?.getParentElm();
                        const data = parentElement?.getParams()?.props?.product ||
                            parentElement?.getParams()?.props?.productData ||
                            parentElement?.getParams()?.props?.data ||
                            parentElement?.getParentElm()?.getParams()?.props?.productData ||
                            parentElement?.getParentElm()?.getParentElm()?.getParams()?.props?.product;

                        let productId = data.id;
                        if (data?.split_product) {
                           productId = data.variant_id;
                        }
                        
                        let productItem = document.querySelector('[data-product-id="' + productId + '"]');

                        if (boostSDCustomConfig && boostSDCustomConfig?.customer_tags && boostSDCustomConfig.customer_tags.length > 0) {
                            let newPriceHtml = buildPriceItem(data, boostSDCustomConfig, formatMoneyHelper);
                            if (productItem.querySelector('.boost-sd__product-price')) {
                                productItem.querySelector('.boost-sd__product-price').innerHTML = newPriceHtml;
                            }
                        }
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });

        componentRegistry.useComponentPlugin('SearchProductItem', {
            name: 'Customize Search Product Item Component',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        const parentElement = element?.getParentElm();
                        const data = element?.getParams()?.props?.product ||
                            element?.getParams()?.props?.productData ||
                            element?.getParams()?.props?.data ||
                            element?.getParentElm()?.getParams()?.props?.productData ||
                            element?.getParentElm()?.getParentElm()?.getParams()?.props?.product;

                        let productId = data.id;
                        if (data?.split_product) {
                           productId = data.variant_id;
                        }
                        
                        let productItem = document.querySelector('.boost-sd__suggestion-queries-item[data-id="' + productId + '"]');

                        if (boostSDCustomConfig && boostSDCustomConfig?.customer_tags && boostSDCustomConfig.customer_tags.length > 0) {
                            let newPriceHtml = buildPriceItem(data, boostSDCustomConfig, formatMoneyHelper);
                            if (productItem.querySelector('.boost-sd__suggestion-queries-item-price')) {
                                productItem.querySelector('.boost-sd__suggestion-queries-item-price').innerHTML = newPriceHtml;
                            }
                        } else {
                            if (parseFloat(data.price_min) !== parseFloat(data.price_max) && !(parseFloat(data.compare_at_price_min) > parseFloat(data.price_min))) {
                                let newPriceHtml = '<span class="boost-sd__format-currency">';
                                newPriceHtml += '<span class="" style="font-size: 14px; font-family: Sackers Gothic">' + formatMoneyHelper(Number(data.price_min), window.boostSDAppConfig?.shop?.money_format, true) + '</span>';
                                newPriceHtml += ' - <span class="" style="font-size: 13px; font-family: Sackers Gothic">' + formatMoneyHelper(Number(data.price_max), window.boostSDAppConfig?.shop?.money_format, true) + '</span>';
                                newPriceHtml += '</span>';
                                if (productItem.querySelector('.boost-sd__suggestion-queries-item-price')) {
                                    productItem.querySelector('.boost-sd__suggestion-queries-item-price').innerHTML = newPriceHtml;
                                }
                            }
                        }
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
      
        componentRegistry.useComponentPlugin('ProductLabel', {
            name: 'Modify Product Label',
            apply: () => ({
                props: (props, element) => {
                    try {
                        if (props.labelType === 'customLabelByTag') {
                            if (props.labelText === 'Treillage') {
                                props.color = '#63716c' // add your colors here
                                //console.log(props)
                            }
                        }
                    } catch (error) {
                        console.log(error)
                    }
                    return props;
                }
            }),
        });
    }
]);
/* move toolbar */
$(window).on('load', function() {
    if ($(window).width() > 767) {
        setTimeout(function() {
            $('.boost-sd__toolbar-container').insertBefore('.boost-sd-layout--has-filter-vertical .boost-sd__pagination-infinite-scroll-container');
        }, 500);
    }
});